import React from 'react';
import Services from './../services/services';
import Breadcrumb from './../basics/Breadcrumb';
import Notification from './../basics/Notification';
import ProductTerms from './ProductTerms';
import ProductMap from './ProductMap';

import { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";

const ProductDetail = () => {

  const services = new Services();

  let {id} = useParams();

  let firstImage = '';

  const [product, setProduct] = useState<any>(null);

  const [productName, setProductName] = useState<any>();

  const [bigImage, setBigImage] = useState<any>();

  const [notification, setNotification] = useState<any>();

  const [images, setImages] = useState([]);

  const [propositions, setPropositions] = useState([]);

  const [places, setPlaces] = useState([]);

  const [selectedPlace, setSelectedPlace] = useState<any>({latitude: 0, longitude: 0});

  const [idProductPlace, setProductPlace] = useState("");

  const [count, setCount] = useState('1');

  const gallery: any[] = [];

  const propsList: any[] = [];

  useEffect(()=>{

    services.getProduct(id).then( (value: any) => {

      setProduct(value)
      setImages(value.attachment)
      setPropositions(value.additionalText)

    });

    services.getProductPlaces().then( (value: any) => {

      setPlaces(value)

      setSelectedPlace({latitude: value[0].latitude, longitude: value[0].longitude})

      setProductPlace(value[0].id)
    });

  }, [ id ])

  useEffect(()=>{

    setBigImage(firstImage)

  }, [ product ])

  const submitForm = (event: any) => {

    event.preventDefault();

    let orderId: any = localStorage.getItem('orderId');

    services.addToCart(orderId, product.id, idProductPlace, count ).then( (value: any) => {

    });

    setNotification(<Notification text={ "Produkt "+product.name+" byl přidán do košíku"} link="/cart" linkText="Zobrazit košík"/>)

  }

  const selectPlace = (event: any) => {

    console.log(event)

    const idx = event.target.selectedIndex;
    const option = event.target.querySelectorAll('option')[idx];
    const newLatitude = option.getAttribute('data-lat');
    const newLongitude = option.getAttribute('data-long');

    let newSelectedPlace = {latitude: newLatitude, longitude: newLongitude}

    console.log(newSelectedPlace)

    setSelectedPlace(newSelectedPlace);

    setProductPlace(event.target.value)

  }

  let first:boolean = true;
  let firstAddress:string = '';

  images.forEach((data: any) => {

    let address = 'http://api-balony.techcrowd.cz/'+data.path;

    if( first ){ firstImage = address }
    gallery.push(<div className="col-3 rounded-5 img-container-1-1 img-container scale-hover" onClick={ () => setBigImage(address) }><img className="rounded-5" src={address}/></div>)

    first = false;

  })

  propositions.forEach((data: any) => {

    propsList.push(<div className="fs-4"><i className="text-primary fa-solid fa-check me-2"></i> {data.text}</div>)

  })

  const placesList: any[] = [];

  first = true;

  places.forEach((data: any) => {

    if( first ){
      placesList.push(<option value={data.id} data-lat={data.latitude} data-long={data.longitude} selected>{data.name}</option>)
    }else{
      placesList.push(<option value={data.id} data-lat={data.latitude} data-long={data.longitude}>{data.name}</option>)
    }


    first = false;
  })

  let breadcrumbs = [

    {'name':'Obchod', 'link':'/', 'active': true},
    {'name': id,'link': id, 'active': false}

  ];

  if( product !== null ){

    breadcrumbs = [

      {'name':'Obchod', 'link':'/', 'active': true},
      {'name': product.name,'link': product.name, 'active': false}

    ];

  }


  return (

    <div>

    <div className="product container mt-5 pt-5">

      {notification}

      <Breadcrumb links={breadcrumbs} />

      <div className="row">

        <div className="col-12 col-lg-6">
          <div className="col-12 rounded-5 img-container-4-3 img-container mb-3"><img src={bigImage} className="col-12 rounded-5"/></div>
          <div className="row g-3">{gallery}</div>
        </div>

        <div className="col-12 col-lg-6 ps-5 ">

          <div className="row mb-4">
            <div className="col-12 col-lg-1 pt-1">
              <i className="text-muted fs-3 fa-solid fa-ticket"></i>
            </div>
            <div className="col-12 col-lg-11">
              <hr />
            </div>
          </div>

          <h2>{product ? product.name : ''}</h2>
          <p>{product ? product.description : ''}</p>
          <form onSubmit={submitForm}>
          <div className="mb-3 row">
            <label htmlFor="staticEmail" className="col-auto col-form-label"><strong>Vyberte místo vzletu</strong></label>
            <div className="col-auto">
              <select onChange={(e) => selectPlace(e)} className="form-control form-select mb-3 border-0" aria-label=".form-select-lg example">
                {placesList}
              </select>
            </div>
          </div>

            <p className="fs-2 text-primary">
              <strong>
                {product ? product.price : ''} Kč
              </strong>
            </p>
            <div className="row">
              <div className="col-3">
                <input onChange={(e) => setCount(e.target.value)} value={count} min="1" type="number" className="form-control form-control-lg" />
              </div>
              <div className="col-9">
                <button type="submit" className="btn btn-lg btn-primary rounded-pill">Přidat do košíku</button>
              </div>
            </div>
          </form>
        </div>

      </div>

      <ProductTerms id={id}/>

    </div>

    <div className="bg-light">

      <div className="container py-5">
        <div className="row">
          <div className="col-12 col-lg-6">
            <h2 className="text-primary mb-4">V ceně letenky získáte</h2>
            {propsList}
          </div>
          <div className="col-12 col-lg-6 custom-radius overflow-h">
            <ProductMap latitude={selectedPlace.latitude} longitude={selectedPlace.longitude}/>
          </div>
        </div>
      </div>

    </div>

    </div>
  );

}

export default ProductDetail;
